// fileService.ts
import apolloClient from '@/apollo/client';
import { FileDownloadUrlDocument } from '@/gql/graphql';

export async function getFileDownloadUrl(
  bucketId: number,
  objectName: string,
  expirationMinutes?: number,
  queryParameters?: Record<string, string>,
  purpose?: string
): Promise<string | null> {
  try {
    const { data, errors } = await apolloClient.query({
      query: FileDownloadUrlDocument,
      variables: {
        bucketId,
        objectName,
        expirationMinutes,
        queryParameters,
        purpose,
      },
      fetchPolicy: 'network-only', // ensure we get fresh data
    });
    if (errors && errors.length > 0) {
      const errorMessages = errors.map((error) => error.message).join(', ');
      console.error('Error fetching file download URL:', errorMessages);
      throw new Error('Error fetching file download URL: ' + errorMessages);
    }
    if (data.fileDownloadUrl) {
      return data.fileDownloadUrl;
    } else {
      throw new Error('No file download URL found: ' + data);
    }
  } catch (error) {
    console.error('Error fetching file download URL:', error);
    return null;
  }
}
